import { useRef, useEffect } from 'react';

/**
 * Hook для сброса dirty состояния Formik после успешной операции
 * @param {boolean} isSuccess - флаг успешной операции
 * @param {function} onSuccess - callback который вызывается после сброса dirty состояния
 * @param {number} delay - задержка перед вызовом onSuccess (по умолчанию 100ms)
 */
const useFormikSuccessReset = (isSuccess, onSuccess, delay = 100) => {
  const formikRef = useRef();

  useEffect(() => {
    if (isSuccess && formikRef.current && onSuccess) {
      // Reset Formik dirty state while keeping current values
      if (formikRef.current) {
        // Update initialValues to current values and reset to make dirty = false
        const currentValues = formikRef.current.values;
        formikRef.current.resetForm({
          values: currentValues,
          initialValues: currentValues,
        });
      }

      // Delay callback to allow Formik state to update
      setTimeout(() => {
        onSuccess();
      }, delay);
    }
  }, [isSuccess, onSuccess, delay]);

  return formikRef;
};

export default useFormikSuccessReset;
